import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import WorkSheetActions from '../../../../reducers/modules/report/work-sheet/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/work-sheet'

export default class WorkSheetMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(WorkSheetActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      WorkSheetMiddleware.showOne(dispatch, params);
      dispatch(WorkSheetActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(WorkSheetActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(WorkSheetActions.process());
          WorkSheetMiddleware.showlist(dispatch, params);
        };
  }
  static showExcel(params){
    return (dispatch) => {
        dispatch(WorkSheetActions.process());
        WorkSheetMiddleware.beforeShowExcel(dispatch, params);
      };
}

static getPrint(params) {
  return (dispatch) => {
    dispatch(WorkSheetActions.beforePrint());
    WorkSheetMiddleware.showPrint(dispatch, params);
  };
}

  static beforeShowExcel(dispatch, params) {
 
  } 

  static listing(params){
    return (dispatch) => {
        dispatch(WorkSheetActions.process());
        WorkSheetMiddleware.showlisting(dispatch, params);
      };
}
  static reset(){
    return (dispatch) => {
        dispatch(WorkSheetActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(WorkSheetActions.view());
        WorkSheetMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(WorkSheetActions.submit());
        WorkSheetMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(WorkSheetActions.submit());
        WorkSheetMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(WorkSheetActions.delete());
        WorkSheetMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      WorkSheetMiddleware.showHelper(dispatch,params);
      };
  }

  static showPrint(dispatch, params) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL +'report/work-sheet/pdf',
      responseType: "json",
      data:params
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WorkSheetActions.print(response.data.result));
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch, error);
      });
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-work-sheet' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(WorkSheetActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(WorkSheetActions.list(response.data.result));
          }
        })
        .catch((error) => {
          WorkSheetMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(WorkSheetActions.list(response.data.result));
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WorkSheetActions.view(response.data.result));
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(WorkSheetActions.process(),WorkSheetMiddleware.showlist(dispatch, params));
          WorkSheetMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WorkSheetActions.process(),WorkSheetMiddleware.showlist(dispatch,search));
          dispatch(WorkSheetActions.success());
          WorkSheetMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${WorkSheetMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(WorkSheetActions.process(),WorkSheetActions.showlist(dispatch,search));
          // dispatch(WorkSheetActions.success());
          // WorkSheetMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        WorkSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(WorkSheetActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(WorkSheetActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
